<template>
  <v-navigation-drawer 
    v-model="navDrawer"
    temporary
    app
  >
    <UserInfo/>
    <v-divider></v-divider>
    <ListItems/>
  </v-navigation-drawer>
</template>

<script>
import UserInfo from '@/components/structure/side-bar/user';
import ListItems from '@/components/structure/side-bar/items';

export default {

  name : 'Navigation',

  components: {
    UserInfo,
    ListItems
  },

  computed: {
    navDrawer: {
      get () {
        return this.$store.getters['navigation/getNavDrawer'];
      },
      set (value) {
        if(!value)
          this.$store.commit('navigation/SET_DRAWER', value)
      }
    }
  },
};
</script>